import React from "react";
import "./LegalPages.css";
import "./LandingPage.css";
import Footer from "./Footer";

export default function SupportPage() {
  return (
    <div className="legal-page" data-testid="support-page">
      <nav className="lp-nav" data-testid="lp-nav">
        <a href="/" className="lp-nav-logo">ILIK</a>
      </nav>
      <main className="legal-content">
        <h1>Support</h1>
        <p>Need help with ILIK, contact us and we will reply within 2 working days.</p>
        <p>Email: <a href="mailto:support@ilikapp.com">support@ilikapp.com</a></p>
        <p>See our <a href="/privacy">Privacy Policy</a> and <a href="/terms">Terms of Use</a>.</p>
        <p>ILIK does not make medical claims and is not a medical device.</p>
      </main>
      <Footer />
    </div>
  );
}
